import './colors.module-d9df1b1f.js';
import './common.module-a1e46866.js';
import 'react';
import 'classnames';
import './title/component.js';
import { Title } from './title/index.js';
import { Text } from './text/component.js';
import { TitleResponsive } from './title-responsive/component.js';

var Typography = {
    Title: Title,
    Text: Text,
    TitleResponsive: TitleResponsive,
};

export { Typography };
